import { useHeaderHeight } from '@react-navigation/elements'
import { FC, ReactNode } from 'react'
import { KeyboardAvoidingView, StyleSheet, View } from 'react-native'

interface PositionKeyboardAvoiderProps {
    children: ReactNode
    keyboardVerticalOffset?: number
}

const PositionKeyboardAvoider: FC<PositionKeyboardAvoiderProps> = ({
    children,
    keyboardVerticalOffset,
}) => {
    const headerHeight = useHeaderHeight()

    return (
        <KeyboardAvoidingView
            behavior="position"
            keyboardVerticalOffset={keyboardVerticalOffset ?? headerHeight}
            style={styles.container}
        >
            <View style={styles.content}>{children}</View>
        </KeyboardAvoidingView>
    )
}

const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    content: {
        alignItems: 'center',
    },
})

export default PositionKeyboardAvoider
